module.exports = __webpack_public_path__ + "static/media/React.4057b58e.jpg";